import React from 'react';
import BaseSlider from '@react-native-community/slider';
import { withTheme } from '@rneui/themed';
export const UnthemedSlider = ({ ref, ...props }) => {
    return (React.createElement(BaseSlider, { ...props }));
};
export const Slider = withTheme(UnthemedSlider, 'ThemedSlider');
//# sourceMappingURL=Slider.js.map